import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class DomainProfileGuard  {

  constructor(private router: Router) { }

  canLoad(): boolean {
    
    // console.log('domain_profile = proprakan');
    // localStorage.setItem('domain_profile', 'proprakan');
    // return true

    if (window.location.hostname.indexOf('proprakan') > 0) {
      localStorage.setItem('domain_profile', 'proprakan');
    } else {
      localStorage.setItem('domain_profile', 'tiscoinsure');
    }
    return true;
  }
  
}